module.exports = {
    FILE_TYPES: ['pdf', 'jpeg', 'png'],
    FILE_NAME_CHARS_LIMIT: 40,
    FILE_NAME_REGEX: /^[a-z0-9| |_|á|é|í|ó|ú|ñ|ä|ë|ï|ö|ü|ç]+\.[a-z0-9]{3,4}$/ig,
    FILE_NUMBER_LIMIT: 1,
    FILE_SIZE_LIMIT: 5000,
    BROKER_NO_DESTINATION_ACCOUNT_SELECTED: -1,
    MAXIMUM_PRODUCT_LIMIT: 10
};
